
import http, { AUTH_ROUTES } from "../../../services/api";

export const getNotification = async (setNotification, setLoading) => {
  try {
    const result = await http.get(AUTH_ROUTES.GET_NOTIFICATION);
    console.log(result, "Notification");
    setNotification(result?.data?.notifications?.data?.notifications);
    setLoading(false);
  } catch (e) {
    setLoading(false);
    console.log(e?.data?.message, "Notification error");
  }
};
